// extracted by mini-css-extract-plugin
export default {"comment_container":"index_comment_container_WDY-H clearfix","comment_join":"index_comment_join_EKmE-","url_comment":"index_url_comment_WmWGG"};